<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form #auroraSubmitForm="ngForm"
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <div class="unity-form-group col-12 col-sm-4" style="display: inline-block">
          <label for="Agmt_Num">Agmt Num</label>
          <input
            myFocus
            type="text"
            name="Agmt_Num"
            [(ngModel)]="dsCollection.criteria.Agmt_Num"
            ngControl="Agmt_Num"
            (valueChange)="model.dirty = true"
          />
        </div>
        <aurora-button
          class="pull-right margin-l-5"
          style="margin-top: 16px"
          type="submit"
          [loading]="dsCollection && dsCollection.status == 'Loading'"
          variant="primary"
          (click)="auroraSubmitForm.onSubmit($event)"
        >
          Search
        </aurora-button>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>
        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header" style="min-width: 1500px">
            <tr>
              <th style="width: 250px">Entity Name</th>
              <th>Agreement Num</th>
              <th>Eff Date</th>
              <th>Expiration</th>
              <th>Non Expiring Ind</th>
              <th>Agreement Desc</th>
            </tr>

            <tr *ngFor="let agreement of dsCollection.objectNodes" (click)="app.getSelectedText() && select(agreement)">
              <td style="width: 250px">
                {{ agreement.Entity_Name }}
              </td>
              <td>
                {{ agreement.Agmt_Num }}
              </td>
              <td>
                {{ agreement.Eff_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ agreement.Exp_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ agreement.Non_Expiring_Ind }}
              </td>
              <td>
                {{ agreement.Agmt_Desc }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Agreements</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
